module.exports = __webpack_public_path__ + "static/media/BGShadings.3439b382.png";